import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { InputComponent } from '../input/input.component';
import { environment } from '@shared-envs';

@Component({
  selector: 'ark-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
})
export class RadioComponent extends InputComponent implements OnInit {
  _checked = false;

  get checked(): boolean {
    return this._checked;
  }

  @Input() set checked(value: boolean) {
    this._checked = value;
    this.formStates.selected = value;
  }

  @Input() classes = '';
  @Input() showInfoBubble = false;
  @Output() infoBubbleClicked = new EventEmitter<void>();

  constructor(fb: UntypedFormBuilder, translate: TranslateService) {
    super(fb, translate);
  }

  override ngOnInit(): void {
    if (this.disabled) {
      this.formStates.disabled = true;
      this.tabIndex = -1;
    }
  }

  toggleSelection(evt: Event): void {
    evt.preventDefault();
    evt.stopPropagation();
    if (!this.disabled) {
      this.formStates.selected = true;
      this.valueChanged.emit({
        value: this.formStates.selected,
        status: 'VALID',
      });
    }
  }

  override onFocus(): void {
    this.formStates.focused = true;
  }

  override onBlur(): void {
    this.lostFocus.emit({ value: this.formStates.selected, status: 'VALID' });
    this.formStates.focused = false;
  }

  onInfoClick(event: Event): void {
    environment.log('Info bubble clicked - radio component');
    event.stopPropagation();
    this.infoBubbleClicked.emit();
  }
}
